module.exports = __webpack_public_path__ + "img/optima_logo.2fa66035.svg";